import { Get } from "@/ai_studio/http/http.js";

const ModelsResolver = async (to, from, next) => {
  let at = await Get("getmodels");
    to.meta['models'] = at;
    next();
  }
export default ModelsResolver;